import { render, staticRenderFns } from "./ClientToggle.vue?vue&type=template&id=2c767f12&"
import script from "./ClientToggle.vue?vue&type=script&lang=js&"
export * from "./ClientToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports